"use client";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { Block } from "components/Layout";
import Button from "components/Button";
import Input from "components/Form/Input";

import styles from "/forms/LoginStep1/LoginStep1.module.scss";
import postData from "/utils/postData";
import { useSearchParams } from "next/navigation";

import * as Sentry from "@sentry/nextjs";

function LoginStep2({ phoneNumber }: { phoneNumber: string }) {
  const [errorMessage, setErrorMessage] = useState("");

  const searchParams = useSearchParams();
  const referer = searchParams?.get("referer");
  const { register, handleSubmit, errors, formState } = useForm();

  const onSubmit = async (formData: { otp: string }) => {
    setErrorMessage("");

    try {
      await postData(`/api/auth/login/step2`, {
        phoneNumber,
        otp: formData.otp,
        referer // When logging in from a specific page, we want to redirect back to that page
      });
    } catch (error) {
      setErrorMessage(error.message);
      Sentry.captureException(error, { user: { phoneNumber: phoneNumber, otp: formData.otp } });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <Block bottom={6}>
          <p>Sjekk telefonen din, og skriv inn engangskoden.</p>
        </Block>
        <form onSubmit={handleSubmit(onSubmit)} data-animate-in data-animation-order="1">
          <Input
            data-testid="login-step2-input"
            name="otp"
            type="tel"
            label="Engangskode fra SMS"
            widthCharacters="12"
            maxLength="6"
            register={register({
              required: "Skriv din engangskode, 6 siffer",
              pattern: {
                value: /^[0-9]*$/,
                message: "Skriv din engangskode, 6 siffer"
              },
              minLength: {
                value: 6,
                message: "Skriv din engangskode, 6 siffer"
              }
            })}
            error={errors.otp}
            autoFocus
          />

          {errorMessage && (
            <Block top={5}>
              <p className="color--red">{errorMessage}</p>
            </Block>
          )}

          <Block top={6}>
            <Button
              data-testid="login-step2-submit"
              type="submit"
              primary
              disabled={formState.isSubmitting}
              isSubmitting={formState.isSubmitting}
              errors={errors}
            >
              Logg inn
            </Button>
          </Block>
        </form>
      </div>
    </div>
  );
}

export default LoginStep2;
